import API from '@/services/http'
import type * as Types from './type'

/**
 * 导入文件基础配置
 */
export const importConfig = (data: Types.UploadRestrictListReq) => API.admin.post<Types.UploadRestrictListRes>('/api/v2/resource-svc/config/upload-restrict/list', data)
